import { createContext } from "react";
import { Filters } from "react-table";

export default createContext<Filters<object>>([]);
